import moment from 'moment';

/**
 * 工具类-日期处理工具类
 */

const dateFormat = 'YYYY-MM-DD';
const dateMonthFormat = 'YYYY-MM';
const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

/**
 * 将日期转换为 指定格式
 * @param date 待转换的日期
 * @param format 转换格式
 * @returns str 转换后日期
 */
export function parseDateCustom(date, format) {
  try {
    return moment(date).format(format);
  } catch (e) {
    console.error('日期格式转换异常，返回null，原始值：' + date);
    return null;
  }
}

/**
 * 将日期转换为 年-月-日 格式
 * @param date 待转换的日期
 * @returns str 转换后日期
 */
export function parseDate(date) {
  try {
    return moment(date).format(dateFormat);
  } catch (e) {
    console.error('日期格式转换异常，返回null，原始值：' + date);
    return null;
  }
}


/**
 * 将日期转换为 年-月-日 时:分:秒 格式
 * @param date 待转换的日期
 * @returns str 转换后日期
 */
export function parseDateTime(date) {
  try {
    return moment(date).format(dateTimeFormat);
  } catch (e) {
    console.error('日期格式转换异常，返回null，原始值：' + date);
    return null;
  }
}


/**
 * 获取当前日期，年-月-日
 * @returns {string}
 */
export function dateNow() {
  return moment(new Date()).format(dateFormat);
}


/**
 * 获取当前日期，年-月
 * @returns {string}
 */
export function dateMonthNow() {
  return moment(new Date()).format(dateMonthFormat);
}


/**
 * 获取当前日期，年-月-日 时:分:秒
 * @returns {string}
 */
export function dateTimeNow() {
  return moment(new Date()).format(dateTimeFormat);
}

